<template>
	<router-link :to="route" class="time-line-event">
		<div class="detail"></div>
		<div class="event">
			<div>{{ event.title }} | {{ event.description }}</div>
			<div>{{ datetime }}</div>
		</div>
	</router-link>
</template>

<script>
export default {
	props: [
		'event',
		'user_uid',
		'watch_id'
	],
	data () {
		return {
			metadata: {
				data: null,
				loading: false,
				error: null
			},
			datetime: null
		}
	},
	computed: {
		route () {
			let name = ''
			let params = {
				user_uid: this.user_uid,
				watch_id: this.watch_id,
			}

			switch (this.event.type) {
				case 'HR':
					name = 'WatchHealthReportsView'
					params.report_id = this.event.link_id
					break
				case 'MD':
					name = 'WatchMedicalDocumentsView'
					params.category_id = this.event.link_id
					break
				default:
					name = 'WatchDashboard'
			}

			return {
				name,
				params
			}
		}
	},
	methods: {
		getDocumentMetadata () {
			if (!this.event.file) {
				this.$log.warn('watch dashboard timeline event', 'file is null', this.event)()
				return
			}
			
			this.metadata.loading = true
			this.$api.files.getMetadata(this, this.user_uid, this.watch_id, this.event.file).then(response => {
				this.$log.info('watch dashboard timeline event', 'files.getMetadata OK', response)()
				this.metadata.data = response.body
				this.datetime = this.$moment(this.metadata.data.create_time).format('YYYY-MM-DD')
			}).catch(errors => {
				this.$log.error('watch dashboard timeline event', 'files.getMetadata ERROR', errors)()
				this.metadata.error = errors
			}).finally(() => {
				this.metadata.loading = false
			})
		},
	},
	mounted () {
		this.getDocumentMetadata()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/widgets/timeline/TimeLineEvent.vue